import React from 'react';
import './SlotInApp.css';

const SlotInApp: React.FC = () => {
  return (
    <div className="slot-in-app">
      {/* Hero Section */}
      <section className="app-hero">
        <div className="container">
          <div className="app-hero-content">
            <div className="app-hero-text">
              <h1 className="app-title">
                Slot In <span className="app-subtitle">App</span>
              </h1>
              <p className="app-description">
                A simple and efficient scheduling solution for managing time slots and appointments.
              </p>
              <div className="app-cta">
                <a href="mailto:support@gerund.dev" className="btn btn-primary btn-large">
                  Get Support
                </a>
              </div>
            </div>
            <div className="app-hero-visual">
              <div className="app-screenshot">
                <img 
                  src="/slot-in-app-screenshot.png" 
                  alt="Slot In App Screenshot" 
                  className="app-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="app-content">
        <div className="container">
          <div className="simple-content">
            <div className="content-card">
              <h2>Need Help with Slot In?</h2>
              <p>
                We're here to help you get the most out of Slot In. Whether you have questions about 
                features, need technical support, or want to provide feedback, our team is ready to assist.
              </p>
              
              <div className="support-section">
                <div className="support-item">
                  <div className="support-icon">📧</div>
                  <div className="support-content">
                    <h3>Email Support</h3>
                    <p>Get in touch with our support team for any questions or assistance.</p>
                    <a href="mailto:support@gerund.dev" className="btn btn-primary">
                      support@gerund.dev
                    </a>
                  </div>
                </div>
                
                <div className="support-item">
                  <div className="support-icon">📋</div>
                  <div className="support-content">
                    <h3>Privacy Policy</h3>
                    <p>Learn about how we handle your data and privacy.</p>
                    <a href="/slot-in/privacy" className="btn btn-outline">
                      View Privacy Policy
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SlotInApp; 